<div class="entities">

    <!-- Mismo panel de marketing que el de authentication (login-form): misma estructura,
         mismos textos, misma foto de fondo y mismos tamaños. -->
    <section class="entities__panel entities__panel--left">

        <!-- Overlay tonal (efecto multiply como en Figma) -->
        <div class="panel-bg-overlay"></div>

        <div class="panel-content">

            <!-- Titular -->
            <h1 class="panel-headline">
                Tu equipo legal, siempre contigo
            </h1>
            <p class="panel-subheadline">
                Accede y disfruta de todas las ventajas de ser cliente de onLygal
            </p>
        </div>
    </section>

    <section class="entities__panel entities__panel--right">

        <img class="entities__logo" src="/resources/assets/images/Logo-onLygal.png" alt="onLygal" />

        <div class="entities__content">
            <app-selected-entity *ngIf="showEntities"></app-selected-entity>
        </div>

        <img class="entities__illustration" src="/resources/assets/images/entities-illustration.png" alt="" aria-hidden="true" />

    </section>

</div>
